export interface TabClickEventDetail {
  tab: string;
  selected: boolean;
}

export interface TabSizeChangeEventDetail {
  tab: string;
}
